export default {
  //  Mới tạo
   AlreadyCreate: 0,

  // / Chờ kế toán trưởng
  // WaitToChief: 1,

  // / Kế toán trưởng từ chối
  // ChiefReject: -1,

  // / Chờ chủ tài khoản
  // WaitToHead: 2,

  // / Chủ tài khoản từ chối
  // HeadReject: -2,

  // / Chờ GDV tiếp nhận hồ sơ
  WaitKBNNStaff: 5,

  // /GDV từ chối tiếp nhận hồ sơ
  KBNNStaffReject: 6,

  // / GDV đã tiếp nhận hồ sơ
  KBNNStaffApprove: 7,

  // / Chờ trưởng phòng kiểm soát hồ sơ
  WaitKBNNChief: 8,

  // / Trưởng phòng từ chối kiểm soát hồ sơ
  KBNNChiefReject: 9,

  // / Trưởng phòng đã phê duyệt hồ sơ
  KBNNChiefApprove: 12,

  // / KBNN từ chối xử lý hồ sơ
  KBNNReject: 13,
};
